import { makeStyles } from 'tss-react/mui';

import { TABLE_STICKY_HEADER_TOP_VAR } from '../constants';

const useStyles = makeStyles()((theme) => ({
  verticalDivider: {
    width: '1px',
    height: '48px',
    backgroundColor: theme.new.color.line.hairline,
    marginRight: '4px',
    marginLeft: '4px',
    alignSelf: 'center',
  },
  defaultSortIcon: {
    opacity: 1,
    marginLeft: '4px',
  },
  downSortIcon: {
    '& path': {
      stroke: theme.new.color.grey[600],
      strokeWidth: '1',
    },
  },
  mobileViewWidgetContained: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  mobileViewStickyHeader: {
    flexShrink: 0,
    marginBottom: theme.new.spacing.medium,
  },
  mobileScrollBody: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    borderBottom: `1px solid ${theme.new.color.line.hairline}`,
  },
  mobilePaginationFooter: {
    flexShrink: 0,
  },
  mobileViewWidget: {
    [theme.breakpoints.down('md')]: {
      '& .cardItemLabel': {
        color: theme.new.color.grey[600],
        fontSize: '0.875rem',
      },
      '& .cardItemValue': { fontSize: '0.875rem' },
      '& .listCardContent': {
        paddingBottom: '8px',
      },
      '& .accordionContainer': {
        borderRadius: '12px',
        padding: '16px 16px 8px 16px',
      },
      '& .accordionSummary': {
        padding: '0px',
        '& .MuiAccordionSummary-content': {
          justifyContent: 'flex-start',
          margin: '0px',
        },
      },
      '& .cardItemContainer': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        padding: '8px 0px',
        borderTop: `1px solid ${theme.new.color.line.hairline}`,
      },
    },
  },
  searchFilterDiv: {
    display: 'flex',
    padding: '12px',
    flexDirection: 'column',
    backgroundColor: theme.new.color.common.white,
    marginBottom: '16px',
    borderRadius: '12px',
    gap: '8px',
  },
  searchFilterWrapper: {
    display: 'flex',
    gap: '12px',
    '& .searchWrapper': {
      flexGrow: '2',
    },
    [theme.breakpoints.down('md')]: {
      button: {
        width: '48px',
        fontSize: '0',
        '& .MuiButton-icon': { marginLeft: '0' },
      },
    },
  },
  toolbarActions: {
    width: '100%',
    flexDirection: 'row',
    gap: '12px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: '8px',
    },
  },
  table: {
    '& .MuiTableHead-root': {
      '& th.MuiTableCell-head': {
        // Page-scroll only: offset sticky headers below the pinned banner.
        top: `var(${TABLE_STICKY_HEADER_TOP_VAR}, 0px)`,
        alignContent: 'center',
        backgroundColor: theme.new.color.grey[200],
        borderTop: `1px solid ${theme.new.color.line.hairline}`,
        color: theme.new.color.textPrimary,
        fontWeight: '500',
        fontSize: '0.875rem',
        minHeight: '48px',
        padding: '12px',
        justifyContent: 'center',
        '& .Mui-TableHeadCell-Content-Labels > div': {
          whiteSpace: 'wrap',
        },
        '& .MuiCheckbox-root': {
          padding: '0',
        },
      },
      '& .MuiTableCell-root[data-pinned="true"]:before': {
        backgroundColor: `${theme.new.color.grey[200]}`,
      },
    },
    '& .MuiButtonBase-root.Mui-disabled svg': {
      opacity: '0.35',
    },
    '& .MuiTableRow-root:hover td:after': {
      backgroundColor: theme.new.color.brand[100],
    },
    '& .MuiPaper-root': {
      boxShadow: 'none',
      borderRadius: '8px',
    },
    '& .MuiCheckbox-root': {
      margin: 0,
      width: '100%',
      height: '100%',

      '& svg': {
        fill: theme.new.color.border,
        backgroundColor: theme.new.color.background.input,
      },

      '&.Mui-checked, &.MuiCheckbox-indeterminate': {
        '& .MuiSvgIcon-root': {
          fill: theme.new.color.brandPrimary,
        },
      },
    },
    '& .rowHoverClass': {
      cursor: 'pointer',
      '& .Mui-selected': {
        backgroundColor: 'transparent',
      },
      [theme.breakpoints.down('lg')]: {
        fontSize: '0.875rem',
      },
    },
    '& .button': {
      textTransform: 'none',
      fontFamily: 'Inter, "Open Sans", Arial, sans-serif',
      fontWeight: 'normal',
      fontSize: '0.875rem',
      color: theme.new.color.textPrimary,
      border: `1px solid ${theme.new.color.line.hairline}`,
      backgroundColor: theme.new.color.common.white,
      height: '38px',
      minHeight: '38px',
      borderRadius: '8px',
      width: '100%',
      padding: '0px 12px',
      '&:hover': {
        borderColor: theme.new.color.line.hairline,
        backgroundColor: theme.new.color.brand[100],
      },
    },
    '& .MuiTablePagination-root': {
      [theme.breakpoints.down('lg')]: {
        transform: 'scale(0.9)',
      },
    },
    '& tfoot.MuiTableFooter-root': {
      [theme.breakpoints.down('md')]: {
        padding: '0 0 0 8px',
        margin: 0,
      },
    },
    '& .MuiTableSortLabel-root': {
      '&.Mui-active': {
        opacity: 1,
      },
    },
  },
}));

export default useStyles;
